<template>
  <section 
    class="cxco-c-slide"
    role="navigation"
    aria-label="Categories"
  >
  <div 
          class="sr-only" 
          role="status" 
          aria-live="polite"
          aria-atomic="true"
        >
          {{ contentAnnouncement }}
        </div>
    <ol
      v-if="selectedCategories"
      v-resize
      class="cxco-c-slide__content"
      :min-width="state.width"
    >
      <transition-group
        v-bind:css="false"
        v-on:enter="enter"
        v-on:leave="leave"
      >
        <li
          v-for="(selectedCategory, depth) in selectedCategories"
          :key="depth"
          class="cxco-c-slide__item"
          aria-labelledby="cxco-c-slide__title"
        >
          <h2 class="cxco-c-slide__title" :id="`category-${depth}-heading`" v-if="depth > 0">
            {{ state.headings[depth] || selectedCategoryName(depth) }}
          </h2>
          <article 
            class="cxco-c-result"
            :aria-labelledby="`category-${depth}-heading`"
          >
            <ol 
              class="cxco-c-result__list" 
              role="tablist"
              :aria-label="`Category options for ${state.headings[depth] || selectedCategoryName(depth)}`"
            >
              <li
                v-for="category in selectedCategory"
                v-bind:key="category.id"
                role="presentation"
                class="cxco-c-result__item"
              >
                <button
                  class="cxco-c-result__button"
                  role="tab"
                  :id="category.name"
                  :data-state="category.isSelected ? 'selected' : 'deselected'"
                  :aria-pressed="category.isSelected ? 'true' : 'false'"
                  @click="clickCategory(category)"
                >
                  {{ category.name }}
                </button>
              </li>
            </ol>
          </article>
        </li>
      </transition-group>
    </ol>
  </section>
</template>
<script>
import { inject } from "vue";
import smoothScrollIntoView from 'smooth-scroll-into-view-if-needed'
import {
  renderCategoryTree,
  getCategoryById,
  delay,
  scroll,
  debounce,
} from "../utils";

export default {
  setup() {
    const state = inject("state");
    const actions = inject("actions");
    const faqChanged = false
    return { state, actions };
  },
  watch: {
    faqs () {
      this.faqChanged = true
    }
  },
  data(){
    return {
      contentAnnouncement: ''
  }
  },
  computed: {
    selectedCategories() {
      const categories = renderCategoryTree(this.state);
      // Ensure we always have a valid array returned
      return Array.isArray(categories) ? categories : [];
    },
    faqs(){
      return this.state.faqs
    }
  },
  methods: {
    selectedCategoryName(depth) {
      const selectedCategory = getCategoryById(
        this.state.selectedCategories[depth - 1],
        this.state.categories
      );
      return selectedCategory?.name;
    },
    clickCategory(category) {
      this.faqChanged = false
      this.contentAnnouncement = ''
      this.actions.selectCategory(category)
    },
    async enter(el, done) {
      el.setAttribute("data-state", "creating");
      await delay(300);
      el.setAttribute("data-state", "created");
      smoothScrollIntoView(el)

      this.contentAnnouncement = `Category added ${this.faqChanged ? 'and FAQs updated':''}`
      done();
    },
    async leave(el, done) {
      el.setAttribute("data-state", "removing");
      await delay(300);
      this.contentAnnouncement = `Category removed ${this.faqChanged ? 'and FAQs updated':''}`
       done();
    },
  },
  directives: {
    resize: {
      mounted(elm, binding) {
        const actions = binding.instance.actions;

        actions.resize(elm, actions);

        window.addEventListener("resize", function () {
          debounce(actions.resize, 300)(elm, actions);
        });
      },
    },
  },
};
</script>
